import { MAP_TYPES } from '@deck.gl/carto';

const INCOME_SOURCE_ID = 'incomeSource';

const source = {
  id: INCOME_SOURCE_ID,
  type: MAP_TYPES.TABLE,
  connection: 'bmpo-smartmetro-09142026',
  data: `us-con-gcp-npr-0000424-011325.diamond.view_layer_census_data`,
};

export default source;
